export const TrialDurationInDays = 14
export const TrialDurationInMiliseconds = TrialDurationInDays * 24 * 60 * 60 * 1000